<template>
  <SpaceSettingsEditModalTemplate @close="$emit('close')">
    <template v-slot:title>{{ $t('editTitle') }}</template>
    <template v-slot:form>
      <InvestmentsSettingsForm :edit_portfolio="edit_portfolio"
                               @cancelEdit="$emit('close')"/>
    </template>
  </SpaceSettingsEditModalTemplate>
</template>

<script>
import SpaceSettingsEditModalTemplate from "@/components/UI/SpaceSettings/SpaceSettingsEditModalTemplate";
import InvestmentsSettingsForm from "@/components/cabinet/SpaceSettings/InvestmentsSettings/InvestmentsSettingsForm";

export default {
  name: "InvestmentsSettingsEditModal",
  components: {InvestmentsSettingsForm, SpaceSettingsEditModalTemplate},
  props: {
    edit_portfolio: {
      type: Object
    }
  },
  i18n: {
    messages: {
      en: {
        editTitle: 'Edit portfolio'
      },
      ru: {
        editTitle: 'Редактировать портфель'
      }
    }
  }
}
</script>